import { IPublicStudioLinkPagePhone } from "../models/publicStudioLinkPageModels";
import { LinkPageStrokeIcon } from "./LinkPageStrokeIcon";
import styles from "./LinkPageContactCards.module.scss";

interface ILinkPageContactCardsProps {
  address: string | null;
  mapsUrl: string | null;
  phones: IPublicStudioLinkPagePhone[];
}

/**
 * The location and contact cards, above the links. Each is rendered only when the studio chose
 * to publish that detail, and each is a link itself — tapping the location card opens Maps,
 * tapping a number dials it.
 */
export const LinkPageContactCards = ({
  address,
  mapsUrl,
  phones,
}: ILinkPageContactCardsProps) => (
  <div className={styles.root}>
    {!!mapsUrl && (
      <a
        className={`${styles.root_card} ${styles.root_card_tappable}`}
        href={mapsUrl}
        target="_blank"
        rel="noopener noreferrer"
      >
        <span className={styles.root_card_icon}>
          <LinkPageStrokeIcon name="location" className={styles.root_card_icon_svg} />
        </span>

        <span className={styles.root_card_body}>
          <span className={styles.root_card_body_label}>Локация</span>
          {/* A studio can publish an exact map link without publishing the address text —
              the card is still worth showing, but not with an empty line where it goes. */}
          {!!address && (
            <span className={styles.root_card_body_value}>{address}</span>
          )}
          <span className={styles.root_card_body_hint}>
            Отвори в Google Maps
          </span>
        </span>
      </a>
    )}

    {phones.length > 0 && (
      <section className={styles.root_card}>
        <span className={styles.root_card_icon}>
          <LinkPageStrokeIcon name="phone" className={styles.root_card_icon_svg} />
        </span>

        <span className={styles.root_card_body}>
          <span className={styles.root_card_body_label}>Свържете се с нас</span>

          <span className={styles.root_card_body_phones}>
            {phones.map((phone, index) => (
              <a
                className={styles.root_card_body_phones_item}
                href={`tel:${phone.number}`}
                // The number alone is not unique: a studio may list the same line twice, and
                // that is rendered as two rows on purpose.
                key={`${phone.number}-${index}`}
              >
                {!!phone.description && (
                  <span className={styles.root_card_body_phones_item_name}>
                    {phone.description}
                  </span>
                )}
                <span className={styles.root_card_body_phones_item_number}>
                  {phone.number}
                </span>
              </a>
            ))}
          </span>
        </span>
      </section>
    )}
  </div>
);
